<template>
  <div class="minitest"  v-if='cur_data.chapter_type == 2'>
    <!-- 拖拽单多选 -->
    <v-drag ref="vSelect" :key='$route.query.chapter_id' @answerShow='answerShow' v-if='cur_data.chapter_content.quiz_type==4 || cur_data.chapter_content.quiz_type==5'></v-drag>
    <!-- 答案显示结果 -->
    <div :class='{right:cur_data.answer_right,wrong:!cur_data.answer_right}' class="answer_result"  v-show="cur_data.answerShow" v-if='cur_data.chapter_content.quiz_type==1 || cur_data.chapter_content.quiz_type==2'>
      <i></i>{{cur_data.answer_right? $t('answerTrue'):$t('answerFalse')}}<a href="javascript:;" @click='feedBackShow=!feedBackShow'>{{feedBackShow ? $t('turnOff'):$t('view')}} {{$t('answerFeedback')}}</a>
    </div>
    <div class="result-feedback" v-if="feedBackShow">
        <div class="feedback-con" v-if='cur_data.answer_right' v-html="cur_data.chapter_content.feedback.right"></div>
        <div class="feedback-con" v-else v-html="cur_data.chapter_content.feedback ? cur_data.chapter_content.feedback.wrong : ''"></div>
    </div>
    <div class="test_r_con">
      <!-- 判断题 8 -->
      <v-judge ref="vSelect" :key='$route.query.chapter_id' @answerShow='answerShow' v-if='cur_data.chapter_content.quiz_type==8'></v-judge>
      <!-- 单多选 1 2 -->
      <v-select ref="vSelect" :key='$route.query.chapter_id' @answerShow='answerShow' v-if='cur_data.chapter_content.quiz_type==1 || cur_data.chapter_content.quiz_type==2'></v-select>
      <!-- 段落填空 7 多行填空6 判断8 -->
      <v-fillin ref="vSelect" :key='$route.query.chapter_id' @answerShow='answerShow' v-if='cur_data.chapter_content.quiz_type==6 || cur_data.chapter_content.quiz_type==7 || cur_data.chapter_content.quiz_type==3'></v-fillin>
      <div class="test_submit" v-show='cur_data.chapter_content.quiz_type!=4 && cur_data.chapter_content.quiz_type!=5'>
        <div class="submit" @click="testSubmit()" v-show="!cur_data.answerShow">{{$t('submit')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from './select.vue'
import vJudge from './judge.vue'
import vDrag from './drag.vue'
import vFillin from './fillin.vue'

export default {
  name: 'minitest',
  data () {
    return {
      isShow: true, // 未提交
      feedBackShow: false // 反馈框显隐
    }
  },
  components: {
    vSelect,
    vJudge,
    vDrag,
    vFillin
  },
  computed: {
    cur_data () {
      return this.$store.state.cur_data
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    }
  },
  watch: {
    cur_data (o, n) {
      this.getChapterAnswer()
      this.$forceUpdate()
      this.setLessonLocation(this.cur_part_index, this.cur_chap_index, false)
    }
  },
  created () {
  },
  mounted () {
    this.setLessonLocation(this.cur_part_index, this.cur_chap_index, false)
    this.$nextTick(() => {
      this.getChapterAnswer()
      this.$forceUpdate()
    })
  },
  methods: {
    testSubmit () {
      this.$refs.vSelect.submit()
      /* 存小节学习状态 */
      // this.setLessonLocation(this.cur_part_index,this.cur_chap_index,false);
      this.$forceUpdate()
    },
    answerShow (msg) {
      this.isShow = msg
    }
  }
}
</script>

<style lang="less" scoped>
  .minitest {
    font-size: 0.26rem;
    position: relative;
    .answer_result {
        width:100%;
        height: 1.15rem;
        line-height: 1.15rem;
        font-size:.3rem;
        color:#fff;
        box-sizing: border-box;
        i {
          display: inline-block;
          width: .44rem;
          height: .44rem;
          vertical-align: middle;
          margin:0 .2rem 0 .5rem;
          border-radius: 50%;
        }
        &.right {
          background-color: #4AA854;
          i {
            background:url('../../../assets/img/h5/pass.png') no-repeat center / contain;
          }
        }
        &.wrong {
          background-color: #F75D5D;
          i {
            background: url('../../../assets/img/h5/unpass.png') no-repeat center / contain;
          }
        }
         a {
          color: #fff;
          float:right;
          font-size: .2rem;
          text-decoration:underline;
          margin: .2rem;
          line-height:.72rem;
        }
      }
    .result-feedback {
      width: 100%;
      height: calc(100% - 1.87rem);
      position: absolute;
      // top: 1.87rem;
      background-color: rgba(0,0,0,.3);
      z-index: 100;
      .feedback-con {
        background-color: #fff;
        min-height:.72rem;
        padding: .5rem;
        box-sizing: border-box;
      }
    }
    .test_r_con {
      padding: 0 1.2rem .3rem;
    }
    .test_submit {
        padding:0 0 0.3rem;
        box-sizing: border-box;
          .submit {
            display: inline-block;
            width:2rem;
            background-color: @basic-color;
            border-radius:0.06rem;
            margin: 0 auto;
            font-size: .32rem;
            color: #fff;
            text-align: center;
            line-height: .78rem;
            // vertical-align: middle;
          }
      }

  }
</style>
